import { Col, Container, Row } from "react-grid-system";
import { StyledPageHeader } from "../../styles/StyledPage";
import CalendarIcon from "../../assets/img/icons/calendar.svg";
import moment from "moment";
import { Calendar } from "../../components/Calendar";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getCalendarDecisions, getCalendarUnits } from "../../api/calendar/calendar";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { useState } from "react";
import { QueryLoader } from "../../components/Loader";
import { CalendarFilters } from "../../components/Calendar";
import Bar from "../../components/Bar/Bar";
import { Button } from "../../components/Button";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import ArrowIcon from "../../assets/img/icons/arrow-prev.svg";
import { useNavigate } from "react-router-dom";

export default function CalendarPage() {
	const { axiosPrivate } = useAxiosPrivate();
	const navigate = useNavigate();

	const [dateInfo, setDateInfo] = useState();
	const [startDate, setStartDate] = useState(new Date().getFullYear() - 1 + "-01-01");
	const [endDate, setEndDate] = useState(new Date().getFullYear() + 1 + "-12-31");

	const { isLoading, data } = useQuery(["calendarDecisionsList", startDate, endDate], () =>
		getCalendarDecisions(axiosPrivate, startDate, endDate)
	);
	const { isLoading: isUnitsListLoading, data: unitsListData } = useQuery(["calendarUnitsList"], () => getCalendarUnits(axiosPrivate));

	const [resultData, setResultData] = useState();
	const [filteredResultData, setFilteredResultData] = useState();

	const [choosenUnits, setChoosenUnits] = useState();

	const [choosenFilterDates, setChoosenFilterDates] = useState({ decisionDate: true, validFrom: false, validTo: false, review: false });
	const [choosenFilterStatus, setChoosenFilterStatus] = useState({ 1: true, 2: true, 3: true });

	useEffect(() => {
		if (!isUnitsListLoading) {
			const tempChoosenUnits = { all: true };
			for (const unit of unitsListData) {
				tempChoosenUnits[unit.id] = false;
			}
			setChoosenUnits(tempChoosenUnits);
		}
	}, [isUnitsListLoading]);

	useEffect(() => {
		if (!isLoading && !isUnitsListLoading) {
			const generatedData = generateResultData(data);

			setResultData(generatedData);

			const filteredData = filterResults(generatedData);
			setFilteredResultData(filteredData);
		}
	}, [isLoading, isUnitsListLoading, data]);

	useEffect(() => {
		if (dateInfo) {
			const startStr = dateInfo.startStr.split("T");
			const endStr = dateInfo.endStr.split("T");
			const startStrArr = startStr[0].split("-");
			const endStrArr = endStr[0].split("-");

			const start = parseInt(startStrArr[0]) - 1 + "-01-01";
			const end = parseInt(endStrArr[0]) + 1 + "-12-31";

			if (start !== startDate) setStartDate(start);
			if (end !== endDate) setEndDate(end);
		}
	}, [dateInfo]);

	useEffect(() => {
		if (!isLoading && !isUnitsListLoading && resultData) setFilteredResultData(filterResults(resultData));
	}, [choosenFilterDates, choosenUnits, choosenFilterStatus]);

	const filterResults = (array) => {
		const filteredByDateTypes = array.filter((e) => {
			let isIncluded = false;
			for (const dateType of e.dateTypes) {
				if (choosenFilterDates[dateType]) isIncluded = true;
			}

			return isIncluded;
		});

		let filteredByUnits = filteredByDateTypes;
		if (choosenUnits)
			filteredByUnits = filteredByDateTypes.filter((e) => {
				if (choosenUnits.all) return true;
				return choosenUnits[e.unit.id];
			});

		const filteredByStatus = filteredByUnits.filter((e) => {
			return choosenFilterStatus[e.status.id];
		});

		return filteredByStatus;
	};

	return (
		<>
			<Bar infobar={"test"} fullWidth>
				<Button onClick={() => navigate(-1)} bg={false} small icon={ArrowIcon}>
					Back
				</Button>
				<Breadcrumbs />
			</Bar>
			<Container>
				<Row style={{ marginTop: "2rem" }}>
					<Col sm={12} lg={10}>
						<StyledPageHeader>
							<h1>Calendar</h1>
							<div>
								<i>
									<img src={CalendarIcon} alt="Date" />
								</i>
								<span>{`${moment(new Date()).format("YYYY-MM-DD")}`}</span>
							</div>
						</StyledPageHeader>

						{filteredResultData ? <Calendar data={filteredResultData} setDateInfo={setDateInfo} /> : <QueryLoader />}
					</Col>
					<Col sm={12} lg={2}>
						<CalendarFilters
							isUnitsListLoading={isUnitsListLoading}
							choosenUnits={choosenUnits}
							unitsListData={unitsListData}
							setChoosenUnits={setChoosenUnits}
							choosenFilterDates={choosenFilterDates}
							setChoosenFilterDates={setChoosenFilterDates}
							choosenFilterStatus={choosenFilterStatus}
							setChoosenFilterStatus={setChoosenFilterStatus}
						/>
					</Col>
				</Row>
			</Container>
		</>
	);
}

const generateResultData = (data) => {
	const res = [];

	if (!data || typeof data !== "object") return res;

	for (const [key, value] of Object.entries(data)) {
		if (!Array.isArray(value)) continue;

		for (const decisionItem of value) {
			if (!decisionItem || typeof decisionItem !== "object") continue;

			const tempObj = {};
			const sameDecisions = res.filter((e) => e.decisionId === decisionItem.id);

			const decisionDate = decisionItem.decisionDate?.split?.("T")?.[0];
			const validFrom = decisionItem.validFrom?.split?.("T")?.[0];
			const validTo = decisionItem.validTo?.split?.("T")?.[0];
			const reviewDate = decisionItem.review?.date?.split?.("T")?.[0];
			const annualReviewDate = decisionItem.annualReview?.date?.split?.("T")?.[0];

			if (decisionDate === key) {
				tempObj.dateTypes = ["decisionDate"];
				sameDecisions.forEach((d) => d.date === key && d.dateTypes.push("decisionDate"));
			} else if (validFrom === key) {
				tempObj.dateTypes = ["validFrom"];
				sameDecisions.forEach((d) => d.date === key && d.dateTypes.push("validFrom"));
			} else if (validTo === key) {
				tempObj.dateTypes = ["validTo"];
				sameDecisions.forEach((d) => d.date === key && d.dateTypes.push("validTo"));
			} else if (reviewDate === key) {
				tempObj.dateTypes = ["review"];
				sameDecisions.forEach((d) => d.date === key && d.dateTypes.push("review"));
			} else if (annualReviewDate) {
				const dateWithoutYear = annualReviewDate.split("-").slice(1).join("-");
				const keyWithoutYear = key.split("-").slice(1).join("-");
				if (dateWithoutYear === keyWithoutYear) {
					tempObj.dateTypes = ["review"];
					sameDecisions.forEach((d) => d.date === key && d.dateTypes.push("review"));
				}
			} else {
				// No matching date, skip
				continue;
			}

			tempObj.decisionId = decisionItem.id;
			tempObj.title = decisionItem.name ?? "Unnamed";
			tempObj.date = key;
			tempObj.unit = decisionItem.unit ?? {};
			tempObj.status = decisionItem.status ?? {};

			res.push(tempObj);
		}
	}

	return res;
};

